import { createCalmPublicApi } from '@rhg/libs/api/create-calm-public-api';
import { GetCalmPublicProgramResponse } from '@rhg/libs/api/create-calm-public-api/types';
import { queryKeys, useQuery } from '@rhg/libs/react-query';

export const publicProgramQueryOptions = {
    queryKey: (programId: string) => [queryKeys.publicProgram, programId],
    queryFn: async (programId: string) => {
        const calmPublicApi = createCalmPublicApi();

        const response = await calmPublicApi.getCalmPublicProgram(programId);

        return transformCalmProgramResponse(response.data);
    },
    queryOptions: (programId: string) => ({ enabled: !!programId }),
};

function transformCalmProgramResponse(response: GetCalmPublicProgramResponse) {
    return {
        ...response,
        program: {
            ...response.program,
            guides: response.program.guides.map((guide) => ({
                ...guide,
                assets: guide.assets?.map((asset) => ({
                    ...asset,
                    contentType: asset.content_type,
                })),
            })),
        },
    };
}

export function usePublicProgram(programId = '') {
    const { data, ...otherProps } = useQuery({
        queryKey: publicProgramQueryOptions.queryKey(programId),
        queryFn: async () => publicProgramQueryOptions.queryFn(programId),
        ...publicProgramQueryOptions.queryOptions(programId),
    });
    return {
        program: data?.program,
        ...otherProps,
    };
}
